import { render } from "./DisciplineWeekly.vue?vue&type=template&id=0c7f5ce6"
import script from "./DisciplineWeekly.vue?vue&type=script&lang=js"
export * from "./DisciplineWeekly.vue?vue&type=script&lang=js"
script.render = render

export default script